module.exports = "./img/175788ec5c20e0502c28e491fdac2dad.png";